import { z } from 'zod';
import { isIsoData } from './date.js';
/** Data ISO validata da zod, riusabile ovunque. */
export const zIsoData = z.string().refine(isIsoData, { message: 'Data non valida (attesa YYYY-MM-DD)' });
/** Importo in centesimi: intero, mai decimale. */
export const zCentesimi = z.number().int({ message: 'Gli importi sono interi in centesimi' });
export const TIPI_DOCUMENTO = ['ATTIVA', 'PASSIVA'];
export const zTipoDocumento = z.enum(TIPI_DOCUMENTO);
/**
 * Temi (skin) dell'interfaccia, nello stile AdminLTE 2. È una preferenza
 * **personale** — sta sull'utente, non sull'organizzazione — e cambia solo la
 * cornice (barra e sidebar), mai le tinte che significano un dato.
 */
export const TEMI = ['blu', 'verde', 'viola', 'rosso', 'nero'];
export const zTema = z.enum(TEMI);
/**
 * Stato di pagamento **memorizzato**: è un fatto ricavato dagli abbinamenti
 * (quanto del documento risulta incassato/pagato).
 *
 * `SCADUTA` non sta qui di proposito: è una funzione della data di oggi, e
 * memorizzarla vorrebbe dire avere in tabella un valore che diventa falso da
 * solo alla mezzanotte. Si deriva con `statoEsteso()`.
 */
export const STATI_PAGAMENTO = ['DA_PAGARE', 'PARZIALE', 'PAGATA'];
export const zStatoPagamento = z.enum(STATI_PAGAMENTO);
export function statoEsteso(stato, dataAttesa, oggiIso) {
    if (stato === 'PAGATA')
        return 'PAGATA';
    if (dataAttesa && dataAttesa < oggiIso)
        return 'SCADUTA';
    return stato;
}
export const ORIGINI_DOCUMENTO = ['MANUALE', 'XML_SDI', 'FATTURA_IN_CLOUD', 'IMPORT_CSV'];
export const zOrigineDocumento = z.enum(ORIGINI_DOCUMENTO);
export const TIPI_ANAGRAFICA = ['CLIENTE', 'FORNITORE', 'ENTRAMBI'];
export const zTipoAnagrafica = z.enum(TIPI_ANAGRAFICA);
export const VERSI = ['ENTRATA', 'USCITA'];
export const zVerso = z.enum(VERSI);
export const TIPI_CONTO = ['BANCA', 'CASSA', 'CARTA', 'ANTICIPO_FATTURE'];
export const zTipoConto = z.enum(TIPI_CONTO);
/**
 * L'anticipo fatture non è liquidità: è fido utilizzato. Sommarlo alla cassa
 * gonfia il saldo di un'azienda che quei soldi li ha già spesi.
 */
export function contribuisceAllaCassa(tipo) {
    return tipo !== 'ANTICIPO_FATTURE';
}
export const RUOLI = ['ADMIN', 'OPERATORE'];
export const zRuolo = z.enum(RUOLI);
export const PERIODICITA = ['MENSILE', 'BIMESTRALE', 'TRIMESTRALE', 'SEMESTRALE', 'ANNUALE'];
export const zPeriodicita = z.enum(PERIODICITA);
export const MESI_PER_PERIODICITA = {
    MENSILE: 1,
    BIMESTRALE: 2,
    TRIMESTRALE: 3,
    SEMESTRALE: 6,
    ANNUALE: 12,
};
/** Partita IVA italiana: 11 cifre con checksum di Luhn secondo DM 23/12/1976. */
export function partitaIvaValida(piva) {
    const s = piva.replace(/\s/g, '');
    if (!/^\d{11}$/.test(s))
        return false;
    let somma = 0;
    for (let i = 0; i < 11; i++) {
        let c = Number(s[i]);
        if (i % 2 === 1) {
            c *= 2;
            if (c > 9)
                c -= 9;
        }
        somma += c;
    }
    return somma % 10 === 0;
}
/**
 * Normalizza una partita IVA per il confronto: è la chiave di abbinamento con
 * l'XML FatturaPA, mai la denominazione — «S.p.A.», «SpA» e «S.P.A.» sono la
 * stessa azienda.
 */
export function normalizzaPiva(piva) {
    if (!piva)
        return null;
    const s = piva.replace(/[^0-9A-Za-z]/g, '').toUpperCase();
    if (!s)
        return null;
    // Il prefisso paese compare in FatturaPA in un campo a parte, ma a volte
    // finisce incollato al codice: si toglie per non avere due chiavi diverse.
    return /^IT\d{11}$/.test(s) ? s.slice(2) : s;
}
export function normalizzaCodiceFiscale(cf) {
    if (!cf)
        return null;
    const s = cf.replace(/[^0-9A-Za-z]/g, '').toUpperCase();
    return s || null;
}
//# sourceMappingURL=tipi.js.map